(function() {
  const addSaveBuildButton = () => {
    const buttonsContainer = document.querySelector('.cpb-product-actions-container')
    const savedBuild = document.createElement('button')
    const addToCartBtn = document.querySelector('.cpb-add-to-cart-button')
    savedBuild.textContent = 'Save Build'
    addToCartBtn.textContent = 'Save Build'

    if (!!window._cpb.settings === false) window._cpb.settings = {}
    window._cpb.settings.addToCartOverride = async data => {
      const modal = document.createElement("div");
      const configId = await window._cpb.saveConfig(null, false);
      const configLink = `${document.location.origin + document.location.pathname}?configid=${configId}`

      let result = data.items.map((item, index) => {
        const props = item.properties;
        const propsText = Object.entries(props)
          .map(([key, value]) => `${key}: ${value}`)
          .join('\n');
        return `Item ${index + 1}:\n${propsText}`;
      }).join('\n\n');

      modal.className = "modal";
      modal.innerHTML = `
        <div class="modal-content">
          <span class="close">&times;</span>
          <h2>Submit Your Build</h2>
          <p>Submit your custom trailer build below and our team will review your selections. Once we receive your form, one of our specialists will contact you directly to go over pricing, answer questions, and finalize the details. No payment is taken here — just your build preferences.</p>
          <form id="modalForm">
            <input type="text" name="firstname" placeholder="First Name" required />
            <input type="text" name="lastname" placeholder="Last Name" required />
            <input type="email" name="email" placeholder="Email" required />
            <input type="tel" name="phone" placeholder="Phone" />
            <textarea name="notes_to_TDNW_team" class="cpb-modal-form-info" placeholder="Notes to TDNW Team"></textarea>
            <textarea name="configid" class="cpb-modal-form-config" placeholder="Config ID"></textarea>
            <button type="submit" class="cpb-modal-form-button cpb-actions-btn">Submit</button>
          </form>
        </div>
      `;

      const textArea = modal.querySelector('.cpb-modal-form-config')
      textArea.value = result

      document.body.appendChild(modal);
      modal.style.display = "block";

      const closeModal = () => {
        modal.remove();
        document.removeEventListener("keydown", escListener);
      };

      modal.querySelector(".close").onclick = closeModal;

      modal.addEventListener("click", (e) => {
        if (e.target === modal) closeModal();
      });

      const escListener = (e) => {
        if (e.key === "Escape") closeModal();
      };
      document.addEventListener("keydown", escListener);

      const renderSuccess = () => {
        const content = modal.querySelector(".modal-content");
        content.innerHTML = `
          <h2>Thank you!</h2>
          <p>Thank you! Your build has been sent to our team. We’ll reach out within 1–2 business days to walk through your options and next steps.</p>
          <button type="button" class="cpb-actions-btn modal-close-ok">Close</button>
        `;
        content.querySelector(".modal-close-ok").addEventListener("click", closeModal);
      };

      modal.querySelector("form").onsubmit = async (e) => {
        e.preventDefault();
        const form = new FormData(e.target);
        const formData = Object.fromEntries(form.entries());
        const data = {
          fields: [
            {
              name: "firstname",
              value: formData.firstname
            },
            {
              name: "lastname",
              value: formData.lastname
            },
            {
              name: "email",
              value: formData.email
            },
            {
              name: "phone",
              value: formData.phone
            },
            {
              name: "notes_to_TDNW_team",
              value: formData.notes_to_TDNW_team
            },
            {
              name: "configid",
              value: formData.configid
            },
          ]
        };
        const response = await fetch("https://api.hsforms.com/submissions/v3/integration/submit/3798303/83f74cc2-04c5-4b26-bfbb-0826a23dc0fd", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        });
        const resText = await response.text();

        if (response.ok) {
          renderSuccess()
        }
        console.log(resText, 'resText')
    
        // closeModal();
      };
    }
  }

  const fixMobileWidth = (width) => {
    const productBuilder = document.querySelector('#product-builder')
    productBuilder.style.width = `${width - 30}px`
  }

  const showDescription = (detail) => {
    const productDescription = document.querySelector('.cpb-product-description')
    if (!productDescription) return

    if (detail.currentIndex !== 0) {
      productDescription.style.display = 'none'
    } else {
      productDescription.style.display = 'block'
    }
  }

  const fixSectionStyle = () => {
    const builder = document.querySelector('#product-builder')
    const section = builder.closest('.layout-panel-flex')

    section.style.display = 'block'
  }
  
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
    console.log('mount')
    fixSectionStyle();
    addSaveBuildButton();
    if (window.outerWidth < 999) {
      fixMobileWidth(window.outerWidth)
    }
  })

  document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', function({detail}) {
    showDescription(detail)
  }) 

  window.addEventListener("resize", () => {
    if (window.outerWidth < 999) {
      fixMobileWidth(window.outerWidth)
    }
  });
})()